<template>
    <div class="container-fluid">
        <Loading v-if="!loaded"></Loading>
        <div v-else>
            <div class="row">
                <label class="col-sm-2 col-form-label">{{ $t('search') }} by {{ $t('name') }}:</label>
                <div class="col-sm-3">
                    <div class="form-group">
                        <input type="text" class="form-control" />
                    </div>
                </div>
                <div class="col-sm-3 offset-4">
                    <button class="btn btn-primary" v-on:click="this.createAddress">{{ $t('create') }}</button>
                </div>
            </div>
            <table class="table table-hover mt-4">
                <thead>
                    <tr>
                        <th>№</th>
                        <th>{{ $t('name') }}</th>
                        <th>{{ $t('country') }}</th>
                        <th>Region</th>
                        <th>{{ $t('city') }}</th>
                        <th>{{ $t('street') }}</th>
                        <th>{{ $t('zip') }}</th>
                        <th>Phone</th>
                        <th>{{ $t('email') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(address, index) in addresses" v-bind:key="address.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ address.name }}</td>
                        <td>{{ address.country }}</td>
                        <td>{{ address.region }}</td>
                        <td>{{ address.city }}</td>
                        <td>{{ address.street }}</td>
                        <td>{{ address.zip_code }}</td>
                        <td>{{ address.phone }}</td>
                        <td>{{ address.email }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <modals-container />
    </div>
</template>

<script>
import Loading from '@/views/partial/Loading';
import CreatePositionModal from './CreateAddressModal';
import { getAddress, handleAxiosError } from '@/services/axiosService';

export default {
    components: {
        Loading
    },
    data() {
        return {
            addresses: [],
            loaded: false
        };
    },
    async created() {
        await this.fetchAddress();
        this.loaded = true;
    },
    methods: {
        createAddress() {
            this.$modal.show(CreatePositionModal, { fetch: this.fetch }, { height: '420', width: '1280' });
        },
        async fetchAddress() {
            try {
                this.addresses = await getAddress();
            } catch (error) {
                handleAxiosError(error);
            }
        }
    }
};
</script>
